// Copyright (c) Move Closer 2022.

import { ProfileTabItem } from '../../profile/services/profile-tabs'
import { RouteNames } from '../routes'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const orderTabs: ProfileTabItem[] = [
  {
    label: 'historyOfOrders',
    routeName: `orders.${RouteNames.History}`,
    priority: 100
  }
]
